"use strict";
// A web interface to manage a trail guide mobile app's content and data.
// Copyright (C) 2021-2025  David Lougheed
// See NOTICE for more information.
Object.defineProperty(exports, "__esModule", { value: true });
var redux_1 = require("redux");
var actions_1 = require("./actions");
var utils_1 = require("../../utils");
var serverInfoReducer = (0, utils_1.makeGenericNetworkReducer)(actions_1.FETCH_SERVER_INFO, undefined, undefined, undefined, undefined, false);
var serverConfigReducer = (0, utils_1.makeGenericNetworkReducer)(actions_1.FETCH_SERVER_CONFIG, undefined, undefined, undefined, undefined, false);
exports.default = (0, redux_1.combineReducers)({
    info: serverInfoReducer,
    config: serverConfigReducer,
});
